import './App.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { FilterStore, OrganizationStore, ServiceStore, UserStore, EnumStore } from './stores';
import { Provider } from 'mobx-react';
import * as RoutesModule from './routes';
import * as Notifications from 'react-notification-system';
import { NotificationService } from './services';

let routes = RoutesModule.routes;

interface AppState {
  singletons?: any;
}

class App extends React.Component<{}, AppState> {
  private notifications: Notifications.System;

  constructor(props: {}) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const notificationService = new NotificationService(this.notifications);

    this.setState({
      singletons: {
        FilterStore: new FilterStore(notificationService),
        OrganizationStore: new OrganizationStore(notificationService),
        ServiceStore: new ServiceStore(notificationService),
        UserStore: new UserStore(notificationService),
        EnumStore: new EnumStore(notificationService)
      }
    });
  }

  render() {
    const baseUrl = '/';
    const { singletons } = this.state;

    return (
      <div className="app-container">
        <Notifications ref={(c: Notifications.System) => { this.notifications = c; }} />
        {singletons &&
          <Provider {...singletons}>
            <BrowserRouter children={routes} basename={baseUrl} />
          </Provider>
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx